<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
       <div class="bg-white page-border">
          <div class="row row-replace add-m-b">
             <div class="col-md-6 col-9 col-p h5"><i class="fa fa-user-md"></i> Vaccination Requisition Details</div>
             <div class="col-md-6 col-3 top-corner-items col-p">
                <button class="btn btn-primary btn-sm m-r-5" (click)="openModal('#vaccin_req_data')">Vaccination Requisition Form</button>
                <button class="btn btn-warning btn-sm m-r-5"><i class="fa fa-download" aria-hidden="true"></i>Download Reports</button>
                <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/covid19']"><i class="fa fa-arrow-left"></i> Back</button>
             </div>
          </div>
          <div class="row m-t-30">
            <div class="col-12">
               <div class="table-responsive">
                  <table class="table table-striped table-bordered table-sm ">
                     <thead>
                        <tr class="bg-primary text-white">
                           <th>Sr No.</th>
                           <th>PC Codes</th>
                           <th>Partner Id</th>
                           <th>No of Employees to be Vaccinated</th>
                           <th>Comp Type</th>
                           <th>Vaccination Date</th>
                           <th>Admin Remark</th>
                           <th>Vaccination Confirmation Date</th>
                           <th>Status</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr>
                           <td>1</td>
                           <td>2</td>
                           <td>3</td>
                           <td>4</td>
                           <td>5</td>
                           <td>6</td>
                           <td>7</td>
                           <td>8</td>
                           <td>9</td>

                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

    </div>
</div>
</div>
        
<!----Model-->>
<div id="vaccin_req_data" class="modal  custom-modal fade" data-backdrop="static" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
       <div class="modal-content">
          <div class="modal-header">
             <h5 class="modal-title" id="zero_country_form_title">Vaccination Requisition Form</h5>
             <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()"><span aria-hidden="true">&times;</span></button>
          </div>
          <!-- <form [formGroup]="accomondationForm" (ngSubmit)="submitAccomondationData()"> -->
          <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Choose PC CODE from dropdown<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-8">
                      <input type="text" class="form-control">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Open partner list to identify the channel</label>
                    </div>
                    <div class="col-8">
                      <input type="text" class="form-control" placeholder="Emp ID">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Vaccination Partner Channel<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-8">
                        vaccination at partner hospita<span class="text-danger">*</span><input type="radio" >
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Enter Partner Id<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-8">
                        <input type="text" class="form-control">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-12">
                        <p>Please selected atleast three dates options to vaccinate your employees 
                            ( admin department will contact Partner and inform 
                            you about the confirm date from the options below)</p>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Vaccination Date 1<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-8">
                        <input type="date" class="form-control" readonly>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Vaccination Date 2<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-8">
                        <input type="date" class="form-control" readonly>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <label for="aaaa">Vaccination Date 3<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-8">
                        <input type="date" class="form-control" readonly>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-12">
                        <p><b>I hereby confirm that I will collect Employee declaration form for 
                            each of the employee getting vaccinated through this program . 
                            I will store the employee consent form in the personal file of 
                            the employee at the site location.</b></p>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-12">
                        <p>Please accept the above terms & conditions
                        <input type="checkbox"></p>

                    </div>
                </div>
            </div>

          </div>
          <div class="modal-footer">
             <button type="submit" class="btn btn-primary btn-sm ">Submit</button>
          </div>
          <!-- </form> -->
       </div>
    </div>
 </div>
